import React from 'react';
import LaddaButton, { S, EXPAND_RIGHT } from 'react-ladda';

const ButtonComponent = ({loading, toggle, color, buttonText}) => {
    color = (color) ? color : '#43a8df';
    buttonText = (buttonText) ? buttonText : 'Submit';
    return (
        <LaddaButton
            loading={loading}
            onClick={toggle}
            data-color={color}
            data-size={S}
            data-style={EXPAND_RIGHT}
            data-spinner-size={30}
            data-spinner-color="#fff"
            data-spinner-lines={12}
         >
            {buttonText}
        </LaddaButton>
    );
};

export default ButtonComponent;



// WEBPACK FOOTER //
// ./src/views/utils/ButtonComponent.js